module["exports"] = [
  "#{city_name}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de_AT/address/city.js
// module id = 1111
// module chunks = 0